
import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding

const onboardingMetricsSelector = createSelector(
	[getOnboardingData],
	onboarding => ({
		visit_time: onboarding.visit_time,
		step: onboarding.step,
		number_of_previews: onboarding.number_of_previews,
	})
)

export default onboardingMetricsSelector
